module.exports = __webpack_public_path__ + "img/position-accepted.4dff40e0.svg";